import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import classNames from "classnames";
export const RadioGroup = (param)=>{
    let { children, className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixRadioGroup.Root, {
        className: classNames("flex flex-col gap-3", className),
        ...restOfProps,
        children: children
    });
};
